export type PromoRibbonTheme = {
  bg: string;
  pattern?: string;
  patternMobile?: { size: string; position: string };
  patternDesktop?: { size: string; position: string };
  text: string;
  buttonBg: string;
  buttonBgHover: string;
  buttonText: string;
  closeVariant: 'black' | 'white';
};

const DEFAULT_THEME: PromoRibbonTheme = {
  bg: '#FFC940',
  text: '#000000',
  buttonBg: '#DE1D8D',
  buttonBgHover: '#FFFFFF',
  buttonText: '#FFFFFF',
  closeVariant: 'black',
};

export const PROMO_RIBBON_THEMES: Record<string, PromoRibbonTheme> = {
  default: DEFAULT_THEME,

  'mental-health-day': {
    bg: '#004FC2',
    pattern: '/promo-ribbon/clouds.png',
    patternMobile: { size: '300px auto', position: 'left -150px' },
    patternDesktop: { size: '480px auto', position: 'left top' },
    text: '#FFFFFF',
    buttonBg: '#FCD715',
    buttonBgHover: '#E3C00F',
    buttonText: '#000000',
    closeVariant: 'white',
  },

  halloween: {
    bg: '#7900EA',
    pattern: '/promo-ribbon/halloween.png',
    patternMobile: { size: '260px auto', position: 'left -150px' },
    patternDesktop: { size: '480px auto', position: 'left top' },
    text: '#FFFFFF',
    buttonBg: '#FF8600',
    buttonBgHover: '#E07600',
    buttonText: '#000000',
    closeVariant: 'white',
  },

  'veterans-day': {
    bg: '#0030CB',
    pattern: '/promo-ribbon/veterans-day.png',
    patternMobile: { size: '260px auto', position: 'left -50px' },
    patternDesktop: { size: '480px auto', position: 'left top' },
    text: '#FFFFFF',
    buttonBg: '#FF0035',
    buttonBgHover: '#D9002D',
    buttonText: '#FFFFFF',
    closeVariant: 'white',
  },

  'black-friday': {
    bg: '#00774B',
    pattern: '/promo-ribbon/black-friday.png',
    patternMobile: { size: '260px auto', position: 'left -90px' },
    patternDesktop: { size: '480px auto', position: 'left -225px' },
    text: '#FFFFFF',
    buttonBg: '#FF6043',
    buttonBgHover: '#E54B2F',
    buttonText: '#000000',
    closeVariant: 'white',
  },
};

export const getPromoRibbonTheme = (key?: string): PromoRibbonTheme =>
  (key && PROMO_RIBBON_THEMES[key]) || DEFAULT_THEME;
